import { $Q, $Qll } from "../utils/query-selector";
import { deleteAllItems } from "./cart";

let t;

const getRemainingTime = deadline => {
  let now = new Date(),
      remainTime = (new Date(deadline) - now + 1000) / 1000,
      remainSeconds = ('0' + Math.floor(remainTime % 60)).slice(-2),
      remainMinutes = ('0' + Math.floor(remainTime / 60 % 60)).slice(-2)

  return {
    remainSeconds,
    remainMinutes,
    remainTime,
  }
};

function toggleTimmer(switchToggle) {
  const timerWrapper = $Q('.cart-timer');

  if (switchToggle === true) {
    timerWrapper.classList.add('hidden');
  } else {
    timerWrapper.classList.remove('hidden')
  }
}

const countdown = (elem) => {

  const timerUpdate = setInterval(() => {
    t = getRemainingTime(localStorage.getItem('deadline'));
    if (elem) {
      elem.innerHTML = `${t.remainMinutes}:${t.remainSeconds}`;
    }

    if (t.remainTime <= 1) {
      clearInterval(timerUpdate);
      elem.innerHTML = String('00-00');
      deleteAllItems();
      toggleTimmer(true)
    }
  }, 1000)
};

export function addMinutes() {
  const display = $Q('#time');

  if (display) {
    const date = new Date();
    // eslint-disable-next-line max-len
    const deadline = new Date(date.getTime() + parseInt(display.dataset.time, 10) * 60000);

    localStorage.setItem('deadline', deadline);
    toggleTimmer(false)
  }
}

function resetMinutes() {
  const display = $Q('#time');

  if (display) {
    localStorage.setItem('deadline', 0);
  }
}

// eslint-disable-next-line complexity
export function startTimer(init = false) {
  const display = $Q('#time');
  const cartItems = $Qll('.cart-items__container');

  if (display) {
    if (cartItems.length !== 0 && init === false) {
      countdown(display);
      toggleTimmer(false);
    } else if (cartItems.length === 0 && init === false) {
      resetMinutes();
      countdown(display);
      toggleTimmer(true);
    } else if (cartItems.length === 0 && init === true) {
      countdown(display);
    }
  }
}
